/**
 * Created by lihanying on 2017/6/29.
 */
import { API_DOMAIN } from '../../config'
import 'whatwg-fetch'
import { fetchData, postData } from '../../util/index'
import { message } from 'antd'
import { GETCLUBREPERTORY, GETREPERTORYDETAIL, GETPERIOD } from './constants'

export const getClubRepertory = (payload) => {
  return {
    type: GETCLUBREPERTORY,
    payload,
  }
}
export const getRepertoryDetail = (payload) => {
  return {
    type: GETREPERTORYDETAIL,
    payload,
  }
}

export const getPeriod = (payload) => {
  return {
    type: GETPERIOD,
    payload,
  }
}

//库存统计
export function fetchRepertoryList(body) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/BusinessApi/StatisticsTime`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
      dispatch(getClubRepertory(data))
      return data
    })
  }
}

//详情
export function fetchClubRepertoryDetail(body) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/BusinessApi/DetailRecords`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
      dispatch(getRepertoryDetail(data.list))
    })
  }
}

export function fetchTimePeriod(type) {
  return (dispatch, getState) => {
    let startTime = new Date()
    let endTime = new Date()
    // startTime.setHours(17, 0)
    // endTime.setHours(17, 0)
    if (type === '1') {
      //昨天
      startTime.setDate(startTime.getDate() - 1)
    } else if (type === '2') {
      //今日
      endTime.setDate(endTime.getDate())
    } else if (type === '3') {
      //上月
      startTime.setMonth(startTime.getMonth() - 1)
      startTime.setDate(1)
      endTime.setMonth(endTime.getMonth())
      endTime.setDate(1) //1
    } else if (type === '4') {
      //本月
      startTime.setDate(1)
      endTime.setDate(endTime.getDate())
    } else if (type === '5') {
      //去年
      startTime.setFullYear(startTime.getFullYear() - 1)
      startTime.setMonth(0)
      startTime.setDate(1)

      endTime.setMonth(0)
      endTime.setDate(1)
    } else if (type === '6') {
      //今年
      startTime.setMonth(0)
      startTime.setDate(1)
      endTime.setDate(endTime.getDate() + 1)
    }
    console.log(startTime.toISOString().slice(0, 16).replace(/T/, ' '))
    console.log(endTime.toISOString().slice(0, 16).replace(/T/, ' '))
    dispatch(
      getPeriod({
        start_time: startTime.toISOString().slice(0, 10).replace(/T/, ' '),
        end_time: endTime.toISOString().slice(0, 10).replace(/T/, ' '),
      })
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubRepertory/action.js